import type { NavigateOptions } from '@tanstack/react-router'
import { useEffect, useState } from 'react'

export interface UseTasksUrlSyncOptions {
  searchParamsSearch?: string
  navigate: (options: NavigateOptions) => Promise<void>
}

/**
 * 検索テキストをURL search paramsと双方向同期するフック
 *
 * URL→state: searchParamsSearch変更時にstateを更新
 * state→URL: searchText変更時にURLを更新
 */
export function useTasksUrlSync(options: UseTasksUrlSyncOptions) {
  const { searchParamsSearch, navigate } = options

  const [searchText, setSearchText] = useState(searchParamsSearch || '')

  // URL変更時にstateを同期（ブラウザバック等）
  useEffect(() => {
    setSearchText(searchParamsSearch || '')
  }, [searchParamsSearch])

  // 検索テキスト変更時にURLを更新（デバウンス付き）
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate({
        search: (prev: { search?: string }) => ({ ...prev, search: searchText || undefined }),
      })
    }, 1000)
    return () => clearTimeout(timer)
  }, [searchText, navigate])

  return {
    searchText,
    setSearchText,
  }
}
